import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=5e3d3d26&scoped=true&"
import script from "./AppComponent.vue?vue&type=script&lang=js&"
export * from "./AppComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d3d26",
  null
  
)

export default component.exports